export default __webpack_public_path__ + "static/media/usgs_imagery.82280d8c.png";